/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreEntitiesWaitlistModeSchema = z.enum([
  "Manual",
  "Auto",
]);
